import { createSlice } from '@reduxjs/toolkit';

const turboModeSlice = createSlice({
  name: 'turboMode',
  initialState: {
    state:false,
    value: 0,
    ticketId: null,
  },
  reducers: {
    setTurboMode: (state, action) => {
      state = action.payload;

      return state;
    }
  },
});

export const { setTurboMode} = turboModeSlice.actions;
export default turboModeSlice.reducer;
